import React from 'react';
// Portr SDK - api class and methods
import PortrSDK from 'portr-javascript-sdk';
const portrSDK = new PortrSDK();
// globals
import { SET_PNR } from '../../globals';
// styles
const styles = require('./pnr-form.scss');
// images
const imgLuggage = require('../../images/luggage_warning.svg');
const imgSuccess = require('../../images/icon_check.svg');

const API_PATH = process.env.REACT_APP_API_URL;
const SUBSCRIPTIONKEY = process.env.REACT_APP_SUBSCRIPTION_KEY;
const header = {
  'Ocp-Apim-Subscription-Key': SUBSCRIPTIONKEY
};
interface IProps {
  bookingReference: string;
  emailAddress: string;
  multiLang: any;
  language: string;
  airlineName: string;
  airlineCode: string;
}

interface IState {
  bookingPNR: string;
  isBookingPNRValid: boolean;
  isBookingPNRSet: boolean;
}

class PnrFormComponent extends React.Component<IProps, IState> {

  private patternPNR = /^[a-z0-9]{6}$/i;

  constructor(props: any) {
    super(props);
    this.state = {
      bookingPNR: '',
      isBookingPNRValid: true,
      isBookingPNRSet: false
    };
  }

  handlePNRChange(event) {
    this.setState({ bookingPNR: event.target.value.replace(/\s/g, '') });
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.patternPNR.test(this.state.bookingPNR)) {
      const request = {
        pnr: this.state.bookingPNR,
        bookingReference: this.props.bookingReference,
        emailAddress: this.props.emailAddress
      };

      portrSDK.getDataWithHeader(
        API_PATH,
        SET_PNR,
        'post',
        null,
        request,
        null,
        header
      )
        .then((data: any) => {
          this.setState({ isBookingPNRSet: true });
        })
        .catch((error: any) => {

        });
    } else {
      this.setState({ isBookingPNRValid: false });
    }
  }

  public render() {
    const { multiLang, language } = this.props;

    return (
      <div className={styles.wrapper}>

        {!this.state.isBookingPNRSet
          ? <div>
            <div className={styles.header}>
              <img className={styles.icon} src={imgLuggage} alt='' />
              {multiLang[`BookingReferenceText${language}`].replace('%s', this.props.airlineName)}
            </div>
            <form className={styles.form} onSubmit={this.handleSubmit.bind(this)} noValidate>
              <div className={styles.formControl}>
                <input
                  type='text'
                  id='bookingPNR'
                  name='bookingPNR'
                  placeholder={multiLang[`BookingReferencePlaceholder${language}`].replace('%s', this.props.airlineCode)}
                  autoComplete='off'
                  value={this.state.bookingPNR}
                  onChange={this.handlePNRChange.bind(this)}>
                </input>
              </div>
              <button
                type='submit'
                className={styles.btnAccent}>
                {multiLang[`okButton${language}`]}
              </button>
            </form>
            {!this.state.isBookingPNRValid && <p className={styles.errorMessage}>{multiLang[`errorMessageBABookingReference${language}`]}</p>}
          </div>

          : <div className={styles.header}>
            <img className={styles.icon} src={imgSuccess} alt='' />
            {multiLang[`BABookingReferenceThanYouMessage${language}`]}
          </div>
        }
      </div>
    );
  }

};

export default PnrFormComponent;



// WEBPACK FOOTER //
// ./src/components/pnr-form/pnr-form.component.tsx